import { Link } from 'react-router-dom';
import type { Movie } from '@/types';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 影视海报`}
          title={`${movie.title} 剧情介绍与角色`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-900/85 px-2 py-1 text-[11px] font-label text-background-100">
          {movie.category}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-1 text-[11px] font-label text-background-50">
          <i className="ri-star-fill text-[10px]"></i>
          {movie.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3 md:p-4">
        <h3 className="font-heading text-base font-bold text-foreground-950 line-clamp-1 group-hover:text-primary-700 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{movie.subtitle}</p>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {movie.genres.slice(0, 3).map((g) => (
            <span key={g} className="rounded bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
              {g}
            </span>
          ))}
        </div>
        <div className="mt-3 flex items-center justify-between border-t border-background-200/70 pt-2 text-[11px] text-foreground-500">
          <span>{movie.year} · {movie.region}</span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {(movie.views / 10000).toFixed(1)}万
          </span>
        </div>
      </div>
    </Link>
  );
}